import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import Navbar from '../Navbar';
import Menu_Items from '../Menu_Items';
import { VscOutput } from "react-icons/vsc";
import { AiOutlineMergeCells } from "react-icons/ai";
import { DataGrid } from '@mui/x-data-grid';
import { RiExchangeBoxFill } from "react-icons/ri";
import { BiSolidSelectMultiple } from "react-icons/bi";
import { TbTableShare } from "react-icons/tb";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";
import { FaSortDown, FaFileDownload } from "react-icons/fa";
import { FaArrowRightLong, FaCaretUp } from "react-icons/fa6";
import Loader from '../Loader';

function OutBound_Result() {
  const { id, int_id, Ex_id } = useParams();

  const [su_admin, setsu_admin] = useState(false)
  const [admin, setadmin] = useState(false)
  const [monitor, setmonitor] = useState(false)

  const [outbound, setoutbound] = useState({});
  const [loading, setloading] = useState(false)

  const [tables, settables] = useState([]);
  const [values, setvalues] = useState({});
  const [headers, setheaders] = useState({});

  const [datavalues, setdatavalues] = useState([]);
  const [dataheaders, setdataheaders] = useState([])


  const menus = [
    {
      name: 'Integrations',
      id,
    },
    {
      name: 'Out Bound',
      id,
      submenu: [{ name: 'Out Bound', id, int_id, Ex_id },
      { name: 'Conditions', id, int_id, Ex_id },
      { name: 'Linked Tables', id, int_id, Ex_id },
      { name: 'Config', id, int_id, Ex_id },
      { name: 'Result', id, int_id, Ex_id },
      ]
    },
    (su_admin || admin ? { name: 'Users', id } : { name: null, id })
  ];
  const get_level = () => {
    const level = Cookies.get("level");
    if (level === "Super Admin") {
      setsu_admin(true);
    }
    else if (level === 'Admin') {
      setadmin(true)
    }
    else {
      setmonitor(true)
    }

  };
  const getResult = async () => {
    return await axios.get(`/out_bound/result/${Ex_id}`).then((res) => {
      const data = res.data;
      setloading(false)
      return data
    }).catch((err) => {
      toast.error("out_bound trigger error", {
        autoClose: 2000, // 2 seconds
      });
    });
  };
  const getOutBound = async () => {
    await axios.get(`/out_bound/export_value/${Ex_id}`).then(async (res) => {
      const data = res.data;
      const { Config, Output } = data;
      if (Config && Output) {
        const { outputfields = [] } = JSON.parse(Output);
        const parsed = data?.Result_Mapping ? JSON.parse(data.Result_Mapping) : {};
        const HeaderMapping = parsed.HeaderMapping || {};
        const outputfields1 = outputfields.map(field => HeaderMapping[field] || field);
        const headers = [{ field: 'S.No', headerName: 'S.No' }]
        const headers1 = outputfields1.map(name => ({ field: name, headerName: name }))
        const headers2 = [headers, headers1].flat();
        setdataheaders(headers2);
        const resultdata = await getResult();
        const resultdata1 = resultdata.map((obj, index) => {
          obj['S.No'] = index + 1
          return obj
        });
        setdatavalues(resultdata1)
      } else {
        const resultdata = await getResult();
        const tables = Object.keys(resultdata);
        setvalues(resultdata);
        settables(tables);
        let data = {};
        tables.forEach(name => {
          const headers = resultdata[name][0] ? Object.keys(resultdata[name][0]) : [];
          setheaders(prev => ({ ...prev, [name]: headers }));
          data = { ...data, [name]: headers };
        });
        if (tables.length > 0) {
          handleTabs(tables[0], data, resultdata)
        }
      }
      setoutbound(data);
    }).catch((err) => {
      toast.error("get out_bound error", {
        autoClose: 2000, // 2 seconds
      });
    });
  };
  const handleTabs = (name, headers, values) => {
    let data = [{ field: 'S.No', headerName: 'S.No' }];
    const data1 = headers[name].map(head => ({ field: head, headerName: head }));
    const mergeHeaders = [data, data1].flat();
    setdataheaders(mergeHeaders);
    const data2 = values[name].map((obj, index) => {
      obj['S.No'] = index + 1
      return obj
    });
    setdatavalues(data2);
  };
  const Download = () => {
    const { Name, File_Type } = outbound;
    if (File_Type === 'csv') {
      const csvdata = convertToCsv(values)
      const blob = new Blob([csvdata], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${Name}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } else if (File_Type === 'json') {
      const jsondata = convertToJson(values);
      const blob = new Blob([jsondata], { type: "application/json" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${Name}.json`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  const convertToCsv = (jsonData) => {
    let csvRows = [];
    const sections = Object.keys(jsonData); // Get section names like "Jobs", "Status", "SubStatus"
    const sectionData = sections.map(section => jsonData[section].map(row => ({ ...row })));

    // Find max length to merge row-wise
    const maxLength = Math.max(...sectionData.map(arr => arr.length));

    // Extract all unique headers dynamically
    let Headers = new Set();
    sectionData.forEach(section => section.forEach(row => Object.keys(row).forEach(key => Headers.add(key))));
    Headers = Array.from(Headers); // Convert Set to Array

    // Add Headers as the first row
    csvRows.push(Headers.join(","));

    // Merge all sections row-wise
    for (let i = 0; i < maxLength; i++) {
      let rowValues = Headers.map(header => {
        for (let section of sectionData) {
          if (section[i] && section[i][header] !== undefined) {
            return `"${section[i][header]}"`; // Found value
          }
        }
        return `""`; // Default empty if no value
      });
      csvRows.push(rowValues.join(","));
    }

    return csvRows.join("\n");
  };
  const convertToJson = (output) => {
    const arrays = Object.values(output); // get all arrays dynamically
    const maxRows = Math.max(...arrays.map(arr => arr.length));

    const combined = [];

    for (let i = 0; i < maxRows; i++) {
      let row = {};
      arrays.forEach(arr => {
        const item = arr[i] || {};
        Object.keys(item).forEach(key => {
          row[key] = item[key]; // dynamically add keys
        });
      });
      combined.push(row);
    }

    const jsonStr = JSON.stringify(combined, null, 2);

    return jsonStr
  };
  useEffect(() => {
    get_level()
    getOutBound()
  }, []);

  return (
    <div className='container df fdc jb ac'>
      <Navbar />
      <div className='main_box df'>
        <Menu_Items menu={menus} />
        <div className='content df fdc ac of_h'>
          <div className='page_header df jb ac'>
            <div className='w90 h5 df ac'>
              <VscOutput className='page_icon db' />
              <p>Results</p>
            </div>
            <div className='w10 h6 df je ac'>
              <FaFileDownload className='h3 w30 g' onClick={Download} />
            </div>
          </div>
          {
            loading ? <Loader /> : <>
              <div className='w100 h83 white'>
                {
                  tables.length > 0 && <div className='h8 w90 df ac gap1 m1'>
                    {
                      tables.map((table, index) => {
                        return (
                          <button className='h4 w10 pink' key={index} onClick={() => { handleTabs(table, headers, values) }}>{table}</button>
                        )
                      })
                    }
                  </div>
                }

                <DataGrid
                  columns={dataheaders}
                  rows={datavalues}
                  getRowId={(row) => row['S.No']}
                  initialState={{
                    pagination: { paginationModel: { pageSize: 10 } },
                  }}
                  pageSizeOptions={[10, 25, 50, 100]}
                  className='of_a'
                />
              </div>
            </>
          }
        </div>
      </div>
    </div >
  )
}

export default OutBound_Result